export const REDUCER_NAME = 'LoanOperations'

export const pages = {
  operations: 'operations',
  transactions: 'transactions',
}

export const factoryActions = {
  DESTROY: 'LoanOperations/DESTROY',
}

export const actions = {
  INITIALIZE: 'LoanOperations/INITIALIZE',
  SWITCH_PAGE: 'LoanOperations/SWITCH_PAGE',

  CHANGE_NOMINAL: 'LoanOperations/CHANGE_NOMINAL_FLAG',
  CHANGE_ACTIVE_OPERATIONS_FLAG: 'LoanOperations/CHANGE_ACTIVE_OPERATIONS_FLAG',

  FETCH: 'LoanOperations/FETCH',
  FETCH_SUCCESS: 'LoanOperations/FETCH_SUCCESS',
  FETCH_FAILURE: 'LoanOperations/FETCH_FAILURE',
}
